export const CHANGE_THEME = 'CHANGE_THEME'